// @ts-nocheck
import React from 'react'
import blankProfile from "../assets/images/blankprofile.jpg"
import { useSignedImageUrl } from '../hooks/useSignedImageUrl';


interface ProfilePictureRoundedProps {
  /** The S3 location of the picture. */
  pictureURL?: string | null;
  diameter?: number;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  testId?: string;
  /** Replaces the blank-profile image for callers with something better to show — initials, an icon. */
  fallback?: React.ReactNode;
  /** Names the person behind the picture. */
  alt?: string;
  /** Border classes; defaults to the 2px ring, nav avatars pass their thinner one. */
  borderClassName?: string;
}

const ProfilePictureRounded = ({ pictureURL, diameter = 128, className, onClick, testId = undefined, fallback = null, alt = "", borderClassName = "border-2" }: ProfilePictureRoundedProps) => {
    const { url: profilePicUrl, failed, loading, onError: handleError, onLoad: handleLoad } = useSignedImageUrl(pictureURL)

  return (
    <div
    onClick={onClick}
    data-testid={testId}
    style={{
        width: `var(--profile-diameter, ${diameter}px)`,
        height: `var(--profile-diameter, ${diameter}px)`,
      }}
        className={`rounded-full overflow-hidden ${borderClassName} ${className ?? ""}`}>
         {loading ? (
           <div className="w-full h-full bg-eai-surface" />
         ) : profilePicUrl && !failed ? (
           <img
             src={profilePicUrl}
             onError={handleError}
             onLoad={handleLoad}
             alt={alt}
             className="w-full h-full object-cover bg-eai-primary"
           />
         ) : (
           fallback ?? (
             <img
               src={blankProfile}
               alt={alt || "Profile picture"}
               className="w-full h-full object-cover"
             />
           )
         )}
    </div>             
  )
}

export default ProfilePictureRounded
